import type ModelPosition from './model-position';
import type PositiveInteger from './positive-integer';
import type TextPosition from './text-position';
import { assertIsInstanceOfDate, assertIsInstanceOfDateOrNull, assertIsInstanceOfPositiveInteger, assertIsValidPositions } from './assertions';

interface IOrder {
	readonly modificationDate: Date;
	readonly modificationDeadline: Date | null;
	readonly orderDate: Date;
	readonly orderNumber: PositiveInteger;
	readonly positions: Array<ModelPosition | TextPosition>;
}

export default class Order implements IOrder {
	public get modificationDate(): Date {
		return this.#modificationDate;
	}

	public get modificationDeadline(): Date | null {
		return this.#modificationDeadline;
	}

	public get orderDate(): Date {
		return this.#orderDate;
	}

	public get orderNumber(): PositiveInteger {
		return this.#orderNumber;
	}

	public get positions(): Array<ModelPosition | TextPosition> {
		return this.#positions;
	}

	#modificationDate: Date;
	#modificationDeadline: Date | null;
	#orderDate: Date;
	#orderNumber: PositiveInteger;
	#positions: Array<ModelPosition | TextPosition>;

	public constructor({ modificationDate, modificationDeadline, orderDate, orderNumber, positions }: IOrder) {
		assertIsInstanceOfDate(modificationDate);
		this.#modificationDate = modificationDate;
		assertIsInstanceOfDateOrNull(modificationDeadline);
		this.#modificationDeadline = modificationDeadline;
		assertIsInstanceOfDate(orderDate);
		this.#orderDate = orderDate;
		assertIsInstanceOfPositiveInteger(orderNumber);
		this.#orderNumber = orderNumber;
		assertIsValidPositions(positions);
		this.#positions = positions;
	}
}
